var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCollapseLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M45.5625 0.5625H2.4375C1.40039 0.5625 0.5625 1.40039 0.5625 2.4375V45.5625C0.5625 46.5996 1.40039 47.4375 2.4375 47.4375H45.5625C46.5996 47.4375 47.4375 46.5996 47.4375 45.5625V2.4375C47.4375 1.40039 46.5996 0.5625 45.5625 0.5625ZM15.5625 37.5938C15.5625 37.8516 15.3516 38.0625 15.0938 38.0625H10.4062C10.1484 38.0625 9.9375 37.8516 9.9375 37.5938V10.4062C9.9375 10.1484 10.1484 9.9375 10.4062 9.9375H15.0938C15.3516 9.9375 15.5625 10.1484 15.5625 10.4062V37.5938ZM26.8125 21.1875C26.8125 21.4453 26.6016 21.6562 26.3438 21.6562H21.6562C21.3984 21.6562 21.1875 21.4453 21.1875 21.1875V10.4062C21.1875 10.1484 21.3984 9.9375 21.6562 9.9375H26.3438C26.6016 9.9375 26.8125 10.1484 26.8125 10.4062V21.1875ZM38.0625 25.4062C38.0625 25.6641 37.8516 25.875 37.5938 25.875H32.9062C32.6484 25.875 32.4375 25.6641 32.4375 25.4062V10.4062C32.4375 10.1484 32.6484 9.9375 32.9062 9.9375H37.5938C37.8516 9.9375 38.0625 10.1484 38.0625 10.4062V25.4062Z",
    fill: "#F8F8F8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCollapseLogo);
export default __webpack_public_path__ + "static/media/collapse-logo.79676e04.svg";
export { ForwardRef as ReactComponent };